<template>
  <div class="o-documentlisting">
    <h2 class="documentlisting__title">
      {{ $t(titleKey || 'components.documentListing.title') }}
    </h2>

    <ul class="documentlisting__list">
      <li class="list__item item--title" v-if="false">
        <div>
          {{ $t('components.documentListing.list.header.designation') }}
        </div>
        <div v-if="!hideAvailability">
          {{ $t('components.documentListing.list.header.availableFrom') }}
        </div>
      </li>
      <li class="list__item" v-for="document in documents" :key="document.uuid">
        <template v-if="document.link">
          <a :href="document.link" :target="getTarget(document.link)">
            <svg class="svgicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
              <path class="cls-1" d="M624.62,1138.47h251.78c0-139.45,91.67-272.44,237.58-272.44h95.55v-228.54h-95.55c-116.21,0-227.25,58.11-227.25,202.72h-32.28V50h-206.59v790.2h-32.28c0-144.61-111.04-202.72-228.54-202.72h-95.55v228.54h95.55c145.9,0,237.58,132.99,237.58,272.44Z"/>
              <rect class="cls-1" x="134.4" y="1247.37" width="1231.19" height="202.63"/>
            </svg>
            {{ document.title }}
          </a>
          <time v-if="!hideAvailability">{{ document.publish }}</time>
        </template>

        <template v-else>
          <div>{{ document.title }}</div>
          <time v-if="!hideAvailability">{{ document.publish }}</time>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import LinkService from '@/services/LinkService'

export default {
  name: 'DocumentListing',
  props: {
    titleKey: {
      type: String,
      default: null
    },
    documents: {
      type: Array,
      required: true,
      default: () => []
    },
    hideAvailability: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    getTarget(link) {
      return LinkService.getTarget(link)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$documentListing-margin: 1em 0 1em !default;

$documentlisting-list-item-border-width: 1px !default;
$documentlisting-list-item-border-color: $brand-darkgray !default;
$documentlisting-list-item-padding: 0.75em 0 !default;

$documentlisting-list-item-title-padding: 0.75rem 0 !default;
$documentlisting-list-item-title-font-size: 0.75em !default;
$documentlisting-list-item-title-font-weight: $font-weight-bold !default;

$documentlisting-list-item-link-color: $brand-blue !default;
$documentlisting-list-item-link-disabled-color: lighten(
  $brand-blue,
  15%
) !default;

.o-documentlisting {
  margin: $documentListing-margin;

  .svgicon {
      width: 1rem;
      height: 1rem;
      fill: currentColor;
    }

  a {
    text-decoration: none;
  }

  .documentlisting__title {
    font-weight: bold;
    color: $brand-primary;
    font-size: 2.125rem;
    margin-bottom: 1rem;
  }

  .documentlisting__list {
    margin: 0;
    padding: 0;
    list-style: none;

    .list__item {
      display: flex;
      justify-content: space-between;
      padding: $documentlisting-list-item-padding;
      border-bottom: $documentlisting-list-item-border-width solid
        $documentlisting-list-item-border-color;
      line-height: 1;

      &:first-of-type {
        border-top: $documentlisting-list-item-border-width solid
        $documentlisting-list-item-border-color;
      }

      &.item--title {
        padding: $documentlisting-list-item-title-padding;
        font-size: $documentlisting-list-item-title-font-size;
        font-weight: $documentlisting-list-item-title-font-weight;
      }

      a {
        color: $brand-secondary;

        /*
        &[disabled] {
          color: $documentlisting-list-item-link-disabled-color;
        }
        */

        &:hover {
          color: $brand-primary;
        }
      }

      *:last-child {
        text-align: right;
      }
    }
  }
}
</style>
